<template>
  <div>
    <div class="ts-split sga-page-2 page-2">
      <div
        class="ts-selected-tasks"
        v-if="
          sgaYourJob.jobDescriptionTasks &&
            sgaYourJob.jobDescriptionTasks.length >= 1
        "
        style="display: none"
      >
        <div class="content">
          <div class="top" @click="toggleList()">
            <!-- <div class="total">{{ selectedCount }}</div> -->
            <!-- hid count as it only shows count for that session - not total amount of skills selected- rr -->
            <div class="total"><i class="fas fa-check-circle"></i></div>
            <div class="label">Skills Selected</div>
            <img
              class="dropdown"
              src="~../../../../assets/img/down.svg"
              :class="{ flip: hideList }"
            />
          </div>
          <div class="list" :class="{ open: hideList }">
            <div
              class="item"
              v-for="(item, index) in sgaYourJob.jobDescriptionTasks"
              :key="index"
            >
              <span class="label">{{ item }}</span>
              <img
                class="remove"
                src="~../../../../assets/img/remove.svg"
                @click="deleteSelectedItem(item)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="ts-split--section">
        <h3>Your Job</h3>
        <p>
          <strong
            >What tasks/activities do you take part in as part of your home
            life, education, volunteer work, or work?</strong
          ><br /><small>Select all that apply</small>
        </p>

        <el-form @submit.native.prevent>
          <div v-if="selectedRoleCode">
            <div
              v-for="(jobcode, index) in selectedRoleCode"
              :key="`task-${index}`"
            >
              <!-- <span style="padding-top: 20px; display: block; font-size: 15px; font-weight: bold;">Your Job As {{selectedRoleDesc[index]}} </span> -->
              <span
                style="
                  padding-top: 20px;
                  display: block;
                  font-size: 15px;
                  font-weight: bold;
                "
                >Your Job As {{ selectedRoleTitle(jobcode) }}
              </span>
              <div class="ts-comp--multiselect" v-if="jobTasks">
                <div
                  v-for="(task, index) in jobTasks.filter(
                    e =>
                      !sgaYourJob.jobDescriptionTasks
                        .map(m => (m.indexOf('`') > -1 ? m.split('`')[0] : m))
                        .includes(e.description) && e.code == jobcode.trim()
                  )"
                  :key="`task-${index}`"
                >
                  <div
                    class="ts-comp--multiselect-item"
                    @click.stop="handleTaskChange(task)"
                  >
                    <div class="ts-checkbox"></div>
                    <label style="margin-left: 10px">{{
                      task.description
                    }}</label>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>

              <button
                type="button"
                class="ts-btn ts-btn-small ts-btn-grey ts-btn-wicon ts-btn-full mt20 mb20"
                @click="showSearch(index)"
              >
                Can't find what you're looking for
                {{ selectedRoleDesc[index] }} role? Click here to search or add
                your own&nbsp;&nbsp;&nbsp; <v-icon name="search" />
              </button>
              <el-alert
                v-if="retrieveFieldError(modelState, `['${index}'].code`)"
                :title="retrieveFieldError(modelState, `['${index}'].code`)"
                type="error"
                closable="false"
              ></el-alert>
              <el-form-item class="showForm" style="display: none">
                <span
                  v-if="taskSearch[index] && taskSearch[index].length > 6"
                  class="float-right"
                  >Press enter to add as custom task</span
                >
                <input
                  type="text"
                  autocomplete="off"
                  placeholder="Enter a search term..."
                  class="el-input__inner"
                  v-model="taskSearch[index]"
                  v-on:focus="globalIndex = index"
                  v-on:keyup.enter="saveCustomItem(index, jobcode.trim())"
                />

                <div class="ts-comp--multiselect" v-if="hiddenTasks[index]">
                  <div
                    class="ts-comp--multiselect-item"
                    v-for="(task, index) in hiddenTasks[index].filter(
                      e => !sgaYourJob.jobDescriptionTasks.includes(e)
                    )"
                    :key="`task-${index}`"
                  >
                    <div
                      @click.stop="
                        handleTaskChange({
                          description: task,
                          code: jobcode.trim()
                        })
                      "
                    >
                      <div class="ts-checkbox"></div>
                      <label>{{ task }}</label>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>

          <div class="clearfix"></div>
        </el-form>
        <el-alert
          v-if="
            retrieveFieldError(modelState, 'sgaYourJob.jobDescriptionTasks')
          "
          :title="
            retrieveFieldError(modelState, 'sgaYourJob.jobDescriptionTasks')
          "
          type="error"
        ></el-alert>
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          @click="storeSection()"
        >
          Continue
        </button>
        <a class="back-link" href="/sga/questionnaire/">
          <i class="fas fa-chevron-left"></i>Back
        </a>
      </div>

      <div
        class="ts-split--panel"
        v-if="
          sgaYourJob.jobDescriptionTasks &&
            sgaYourJob.jobDescriptionTasks.length
        "
      >
        <div class="ts-split--panel_selection ts-off-canvas">
          <span class="h6">Selected Items</span>
          <transition-group name="list" tag="div">
            <div
              class="item"
              v-for="(item, index) in sgaYourJob.jobDescriptionTasks"
              :key="`ooi-${index}`"
            >
              <i class="ts-icon el-icon-circle-check green"></i>
              <span class="item-label">{{
                item.indexOf("`") ? item.split("`")[0] : item
              }}</span>
              <a class="item-remove" @click="deleteSelectedItem(item)"
                >Remove</a
              >
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page2"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    />
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    />
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import dataDelimiter from "@/utils/data.utils";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection
  },
  mounted() {
    if (this.currentSga.sgaEmployeeInfo.employeeRoleTitle == "N/A") {
      if (sessionStorage.getItem("NavigateAwayFrom") == "page1")
        this.$router.app.$emit("navigateToNextStep");
      else if (sessionStorage.getItem("NavigateAwayFrom") == "page3")
        this.$router.app.$emit("navigateToPreviousStep");
    } else {
      this.isLoading = true;
      this.$store.dispatch("sga/getsga").then(() => {
        if (this.currentSga.sgaYourJob != null) {
          this.sgaYourJob = this.currentSga.sgaYourJob;
        }
        //axios
        // .get(
        //   `${process.env.VUE_APP_API_BASE_URI}onet/jobTasks?onetCode=${this.currentSga.sgaEmployeeInfo.employeeRoleONETCode}`
        // )
        // .then((res) => {
        //   this.$store.dispatch("sga/setJobTasks", res.data);
        //   this.isLoading = false;
        // });

        var test = this.currentSga.sgaEmployeeInfo.employeeRoleONETCode;
        this.$store
          .dispatch(
            "onet/jobTasks",
            this.currentSga.sgaEmployeeInfo.employeeRoleONETCode
          )
          .then(res => {
            this.$store.dispatch("sga/setJobTasks", res);
            this.isLoading = false;
          });
      });
      this.$router.app.$on("questionnaire-print", this.printPage);
      // this.$router.app.$on('cv-print', this.printPageAsCV);
      this.$router.app.$on("show-resume-list", this.showResumeList);
    }

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      showResumeListModal: false,
      globalIndex: 0,
      isLoading: false,
      // addNew: false,
      modelState: {},
      taskSearch: [],
      hiddenTasks: [],
      addCustom: false,
      addCustomI: null,
      selectedCount: 0,
      sgaYourJob: {
        jobRole: {},
        JobDescriptionTasks: [],
        customTasks: []
      },
      windowWidth: null,
      hideList: false,
      sgaEmployeeInfo: {},
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      profile: {},
      profileSettings: []
    };
  },

  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    jobTasks() {
      return this.$store.state.sga.jobDescriptionTasks || [];
      // debugger;
      // let jobDescriptionTask = this.$store.state.sga.jobDescriptionTasks;
      // return jobDescriptionTask ? jobDescriptionTask.split(',') : [];
    },
    selectedRoleCode() {
      let roleCode = this.currentSga.sgaEmployeeInfo.employeeRoleONETCode;
      return roleCode ? roleCode.split(",") : [];

      // return (
      //   this.currentSga.sgaEmployeeInfo.employeeRoleONETCode.split(",") || []
      // );
    },
    selectedRoleDesc() {
      const roleTitle = this.currentSga.sgaEmployeeInfo.employeeRoleTitle || "";
      return roleTitle.split(dataDelimiter) || [];
    },
    getWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      return {
        sgaYourJob: this.sgaYourJob,
        taskSearch: this.taskSearch,
        hiddenTasks: this.hiddenTasks
      };
    },
    page3() {
      return {
        sgaEducation: this.sgaEducation
      };
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });
      return {
        sgaWorkHistory: this.sgaWorkHistory
      };
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });
      return {
        sgaCertifications: this.sgaCertifications
      };
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture
      };
    }
  },

  watch: {
    taskSearch(v) {
      if (!v[this.globalIndex] || v[this.globalIndex].length < 3) {
        this.hiddenTasks[this.globalIndex] = [];
      } else {
        this.getHiddenTasks(v[this.globalIndex]);
      }
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store.dispatch("account/getprofiledetails", obj).then(res => {
        this.profile = res;
        this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
        this.closeResumeListModal();

        this.$refs.cv.showCV(true);
        // this.showProfile = true;
        this.$refs.questionnaire.hideQuestionnaire();
        var x = this.$refs.cv.hideCV;
        window.setTimeout(function() {
          // action();
          window.print();
          x();
        }, 500);
      });
    },
    selectedRoleTitle(code) {
      var roles = this.currentSga.sgaEmployeeInfo.employeeRoleTitleCodeSequence.split(
        ","
      );
      var roleFormatted = "";
      var ctr = 0;
      roles.forEach(element => {
        if (element.trim() == code.trim()) {
          roleFormatted += this.selectedRoleDesc[ctr] + "/";
        }
        ctr++;
      });

      roleFormatted = roleFormatted.substring(0, roleFormatted.length - 1);
      return roleFormatted;
    },
    checkIfCanProceed() {
      if (
        this.currentSga.sgaEmployeeInfo.employeeRoleTitle != "N/A" &&
        this.sgaYourJob.jobDescriptionTasks.length == 0
      ) {
        //this.modelState = { SgaYourJob: {JobDescriptionTasks: ['Please select at least 1 task.']} };
        this.modelState = {
          "sgaYourJob.jobDescriptionTasks": ["Please select at least 1 task."]
        };
        return false;
      } else return true;
    },
    storeSection() {
      var res = this.validTasksCountPerRole(null);
      if (!res) {
        this.$confirm(
          `You can only select 5 tasks per role title!`,
          "Warning",
          {
            confirmButtonText: "Ok",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        );
      } else {
        this.modelState = {};

        // if(this.checkIfCanProceed() == false){
        //   return false;
        // }

        this.isLoading = true;
        this.currentSga.sgaYourJob = this.sgaYourJob;

        var allJobCodeHasJob = true;
        var yourjobsCode = this.currentSga.sgaYourJob.jobDescriptionTasks
          .map(i => {
            var code = i.split("`");
            if (code[1] != null) return i.split("`")[1].trim();
          })
          .filter(i => i != null);

        var allCodes = this.selectedRoleCode.map(i => {
          return i.trim();
        });

        var set = new Set(yourjobsCode);
        var x = allCodes.filter(i => !set.has(i));
        x.forEach(code => {
          this.modelState = {
            ...this.modelState,
            [`['${allCodes.indexOf(code)}'].Code`]: [
              "Select at least 1 task or duty"
            ]
          };
          allJobCodeHasJob = false;
        });

        if (!allJobCodeHasJob) {
          this.$confirm(
            `Select at least 1 task or duty for each role titles.`,
            "Warning",
            {
              confirmButtonText: "OK",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
              type: "warning",
              center: true
            }
          ).then(() => {
            // this.isLoading = false;
            return false;
          });
          this.isLoading = false;
        } else {
          this.currentSga.sgaYourJob.isComplete = true;
          if (this.currentSga.sgaYourJob.id == null) {
            this.$store
              .dispatch("sga/postsga", this.currentSga)
              .then(() => {
                this.$router.app.$emit("navigateToNextStep");
              })
              .catch(res => {
                this.modelState = res.errors;
                this.isLoading = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          } else {
            this.$store
              .dispatch("sga/putsga", this.currentSga)
              .then(() => {
                this.$router.app.$emit("navigateToNextStep");
              })
              .catch(res => {
                this.modelState = res.errors;
                this.isLoading = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          }

          sessionStorage.setItem(
            "sgaDataForPrinting",
            JSON.stringify({
              page1: this.page1,
              page2: {
                sgaYourJob: this.currentSga.sgaYourJob,
                taskSearch: this.taskSearch,
                hiddenTasks: this.hiddenTasks
              }
            })
          );
        }
      }
    },

    getHiddenTasks(searchQuery) {
      this.$store.dispatch("onet/hiddenTasks", { searchQuery }).then(res => {
        this.hiddenTasks[this.globalIndex] = res;
      });
    },

    handleTaskChange(val) {
      var res = this.validTasksCountPerRole(val);
      if (!res) {
        this.$confirm(
          `You can only select 5 tasks per role title!`,
          "Warning",
          {
            confirmButtonText: "Ok",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        );
      } else {
        val = typeof val === "object" ? val.description + "`" + val.code : val;
        if (
          this.sgaYourJob.jobDescriptionTasks &&
          this.sgaYourJob.jobDescriptionTasks.includes(val)
        ) {
          this.sgaYourJob.jobDescriptionTasks = this.sgaYourJob.jobDescriptionTasks.filter(
            vv => vv !== val
          );
        } else {
          this.sgaYourJob.jobDescriptionTasks.push(val);
          if (this.windowWidth > 960) {
            this.$notify({
              title: "Item added",
              position: "bottom-right",
              type: "success"
            });
          }
          this.selectedCount++;
        }
      }
    },
    saveCustomItem(index, code) {
      if (this.taskSearch[index].length > 3) {
        this.addCustomI = this.taskSearch[index] + "`" + code;
        this.sgaYourJob.jobDescriptionTasks.push(this.addCustomI);
        this.sgaYourJob.customTasks.push(this.addCustomI);
        this.taskSearch[index] = this.addCustomI = null; // eslint-disable-line
      }
    },

    deleteSelectedItem(item) {
      this.sgaYourJob.jobDescriptionTasks = this.sgaYourJob.jobDescriptionTasks.filter(
        vv => vv !== item
      );
      this.sgaYourJob.customTasks = this.sgaYourJob.customTasks.filter(
        vv => vv !== item
      );
      this.selectedCount--;
    },

    toggleList() {
      if (this.hideList == false) {
        this.hideList = true;
      } else {
        this.hideList = false;
      }
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        // if (data.IsComplete) {
        //   this.sgaEducation = data.SgaEducation || this.sgaEducation;
        //   this.sgaWorkHistory = data.SgaWorkHistory || this.sgaWorkHistory;
        //   this.sgaCertifications = data.SgaCertifications || this.sgaCertifications;
        //   this.sgaHiddenExtras = data.SgaHiddenExtras || this.sgaHiddenExtras;
        //   this.sgaKnowledge = data.SgaKnowledge || this.sgaKnowledge;
        //   this.sgaMindset = data.SgaMindset || this.sgaMindset;
        //   this.sgaSkills = data.SgaSkills || this.sgaSkills;
        //   this.sgaHiddenTalents = data.SgaHiddenTalents || this.sgaHiddenTalents;
        //   this.sgaCulture = data.Culture || this.sgaCulture;
        // }
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    showSearch(index) {
      this.globalIndex = index;
      // this.addNew[index] = true;
      // this.test = true;
      // alert(this.addNew[index]);
      var el = document.getElementsByClassName("showForm");
      el[index].style["display"] = "block";
    },
    validTasksCountPerRole(val) {
      var isValid = false;

      if (val == null) {
        var roles = this.currentSga.sgaEmployeeInfo.employeeRoleONETCode.split(
          ","
        );
        for (let index = 0; index < roles.length; index++) {
          var code = roles[index];
          var tasks = this.sgaYourJob.jobDescriptionTasks.filter(x =>
            x.includes(code.trim())
          );

          if (tasks.length > 5) {
            isValid = false;
            break;
          } else {
            isValid = true;
          }
        }
      } else {
        var tasks = this.sgaYourJob.jobDescriptionTasks.filter(x =>
          x.includes(val.code.trim())
        );

        if (tasks.length >= 5) {
          isValid = false;
        } else {
          isValid = true;
        }
      }

      return isValid;
    }
  }
};
</script>

<style lang="scss">
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.ts-checkbox {
  border-color: #000000 !important;
}
</style>
